import React, { ReactNode, createContext, useContext, useEffect, useState } from 'react';

type NotifObjType =
  | {
      content: string;
      type: 'success' | 'error' | 'warning';
    }
  | undefined;
type FetchContextType = {
  needToFetch: boolean;
  toggleNeedToFetch: (value: boolean) => void;
  notifObj: NotifObjType;
  setNotifObj: (obj: NotifObjType) => void;
};

const FetchContext = createContext<FetchContextType | undefined>(undefined);

export const useFetchContext = () => {
  const context = useContext(FetchContext);

  if (context === undefined) {
    throw new Error('useFetchContext must be used with a FetchContext');
  }

  return context;
};

export const FetchContextProvider = ({ children }: { children: ReactNode }) => {
  const [notifObj, setNotifObj] = useState<NotifObjType>(undefined);
  const [needToFetch, setNeedToFetch] = useState(true);
  const toggleNeedToFetch = (value: boolean) => {
    setNeedToFetch(value);
  };

  useEffect(() => {
    if (needToFetch) {
      toggleNeedToFetch(false);
    }
  }, [needToFetch]);

  const value = {
    notifObj,
    setNotifObj,
    needToFetch,
    toggleNeedToFetch
  };

  return <FetchContext.Provider value={value}>{children}</FetchContext.Provider>;
};
